const predKCData = require('./predKC.json')

let cacheDataKC = undefined

export const checkPredKC = (studentId) => {
  if(!cacheDataKC) {
    cacheDataKC = {}
    predKCData.forEach( studentData => {
      cacheDataKC[studentData.studentId] = studentData.predList
    })
  }

  return studentId in cacheDataKC
}

export const getPredKC = async (studentId, useSleep = false) => {
  if (useSleep) {
    const sleepMS = Math.random() * 1000 + 3000
    await new Promise(resolve => setTimeout(resolve, sleepMS))
  }
  return { data: { item_list: cacheDataKC[studentId] } }
}